import { formatDateTime } from '@/common/utils/formatters'
import { getRecordTypeConfig } from '@/features/tmaisUsers/constants/rewardLedgerEntries.constant'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { ClockIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { CardInfoCell } from './CardInfoCell'

interface CardWrapperProps {
  entry: RewardLedgerEntryData
  children: ReactNode
}

export const CardWrapper = ({ entry, children }: CardWrapperProps) => {
  const { label, icon: Icon } = getRecordTypeConfig(entry)

  const supplierName = entry.establishment_company_branch
    ? entry.establishment_company_branch.general_information.fantasy_name
    : 'Taurus +'

  const formattedDate = formatDateTime(new Date(entry.created_at))

  return (
    <div className="rounded-lg bg-white-100 border border-white-400 p-4 flex flex-col gap-3">
      <div className="flex flex-col gap-y-0.5">
        <p className="text-xs font-light italic">Tipo de registro</p>

        <div className="flex items-center gap-1">
          <Icon className="size-4 text-white-800" />

          <p className="font-bold text-white-800">{label}</p>
        </div>
      </div>

      {children}

      <div className="grid grid-cols-2 gap-2">
        <CardInfoCell label="Data e hora">
          <ClockIcon className="size-4 text-white-300 shrink-0" />

          <p className="text-sm">{formattedDate}</p>
        </CardInfoCell>

        <CardInfoCell label="Fornecedor (Taurus + ou Estabelecimento)">
          <p className="text-sm">{supplierName}</p>
        </CardInfoCell>
      </div>
    </div>
  )
}
